import React, { Component } from 'react'
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Divider from '@mui/material/Divider';
import Input from '@mui/material/Input';
import { GradientButton } from '../GradientButton';
import { Button, Stack } from '@mui/material';
import { SavingsEnvelopesImages } from '../../../utils/mockData';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import IconDialog from '../IconDialog';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TextField } from '@mui/material';
import axios from 'axios';
import { getURLBase, updateHeightAfterContentUpdate } from '../../../utils/helperFns';
import wyzrTheme from '../../../styles/customTheme';


export class CreateNewEnvelope extends Component {

    constructor(props) {
        super(props);
        this.url = getURLBase(true) + "/createenvelope";
        this.state = {
            showIconDialog: false,
            iconsList: SavingsEnvelopesImages,
            selectedIcon: null,
            showLoader: false,
            formValues: {
                name:null,
                goal:"",
                date:new Date()
            },
            formErrors: {
                name : "",
                goal : "",
                date : "",
                icon : ""
            }
        };

    }
    setFormValues = (field,value) => {
        const obj = {...this.state.formValues};
        obj[field] = value;
        this.setState({formValues:obj});
    }
    submitForm = () => {
        
        var formvalues = {...this.state.formValues};
        var errors = {};

        if(formvalues.name === null || formvalues.name === "") 
        errors.name = "Please enter the name!";
        else 
        errors.name = null;

        if(this.state.selectedIcon === null)
        errors.icon = "Please select an icon!";
        else
        errors.icon = null;

        if(formvalues.goal === null || formvalues.goal === "" || formvalues.goal<=0) 
        errors.goal = "Goal amount should be strictly greater than 0!";
        else 
        errors.goal = null;

        if(formvalues.date === null || formvalues.date === "") 
        errors.date = "Please enter the date!";
        else 
        errors.date = null;

        this.setState({formErrors:errors}, () => {
            console.log(this.state);
        })
        if(!errors.name && !errors.goal && !errors.date) {
            let newEnv = {
                "name": formvalues.name,                
                "tgt_amt": formvalues.goal,
                "tgt_date": formvalues.date,
                "icon": this.state.iconName
            }
            console.log("gid",this.props.gid);
            console.log("newEnv",newEnv);
            axios.post(this.url, { gid: this.props.gid, data: newEnv }).then(res => { 
                console.log(res, "<--- res");
            })
            this.setState({showLoader:true});
            // wait for 5 seconds and then redirect to the home page
            setTimeout(() => {
                
                this.props.refreshEnvelopes();
                this.props.toggleHandler(true);
            }
            , 5000);
        }        
    }

    openIconDialog = () => {
        this.setState({
            showIconDialog: true
        })
    }

    closeIconDialog = (icon, iconName=null) => {
        var s = this.state;
        s.selectedIcon = icon;
        s.iconName = iconName;
        s.showIconDialog = false;

        this.setState({s})
    }

    clearIcon = () => {
        var s = this.state;
        s.selectedIcon = null;
        this.setState({ s })
    }

    loader = () => {
        return (
            <img src="/loader.gif" height="25" alt=""/>
        )
    }

    render() {
        return (
            <>
                <Card className="popup" id="child_CreateNewEnvelope">
                    <Grid maxWidth={420} mx={"auto"}>
                        <Box className="popupClose">
                            <IconButton aria-label="Close" onClick={this.props.toggleHandler}>
                                <ArrowBackIcon />
                            </IconButton>
                        </Box>
                        <CardContent textAlign="center">
                            <Box className="popupHeader">
                                <Typography gutterBottom align="center" variant="h4">
                                    Create New Envelope
                                </Typography>
                            </Box>
                            <Box className="popupBody">
                                <Box mt={8}>
                                    <Box className="flex-center-top" mt={2} mb={1} sx={{ justifyContent: "flex-start !important" }}>
                                        <Typography fontWeight="800" fontSize="inherit" flex={0.6}>Name</Typography>
                                        <Box flex={1.8}>
                                        <Input 
                                        id="name"
                                        onChange={(event) => this.setFormValues("name",event.target.value)}
                                        value={this.state.formValues.name}
                                        type='text' 
                                        placeholder="Enter envelope name" 
                                        variant="standard"
                                        disableUnderline sx={{ fontSize: "inherit", fontWeight: 700, width:"100%" }} />
                                        {this.state.formErrors.name ?<Typography variant='caption' color={wyzrTheme.palette.error.light} >
                                        {this.state.formErrors.name}
                                        </Typography>: null }
                                        </Box>
                                       
                                        
                                    </Box>
                                    <Divider />

                                    <Box className="flex-center-top" mt={2} mb={1} sx={{ justifyContent: "flex-start !important" }}>
                                        <Typography fontWeight="800" fontSize="inherit" flex={0.6}>Goal</Typography>
                                        <Box flex={1.8}>
                                        <Input variant="standard" 
                                        inputProps={{min:0}}
                                        id="goal"
                                        onChange={(event) => this.setFormValues("goal",event.target.value)}
                                        value={this.state.formValues.goal}
                                        type='number' placeholder="Enter amount (in £)" disableUnderline sx={{ fontSize: "inherit", fontWeight: 700, width:"100%"}} />
                                        {this.state.formErrors.goal ?<Typography variant='caption' color={wyzrTheme.palette.error.light} >
                                    {this.state.formErrors.goal}
                                        </Typography>: null }
                                    </Box>
                                    
                                        </Box>
                                       
                                    <Divider />

                                    <Box className="flex-center-top" mt={2} mb={1} sx={{ justifyContent: "space-between !important" }}>
                                        <Typography fontWeight="800" fontSize="inherit" flex={0.6}>By</Typography>
                                        <Box flex={1.8}>

                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                minDate={new Date().setDate(new Date().getDate())}
                                                value={this.state.formValues.date}
                                                onChange={(newValue) => {this.setFormValues("date",newValue); console.log(newValue)}}
                                                renderInput={(params) => <TextField 
                                                    value={this.state.formValues.date}
                                                    disableUnderline sx={{ fontSize: "inherit", fontWeight: 700 ,width:"100%"}}  variant="standard" {...params} />}
                                            />
                                        </LocalizationProvider>
                                        {this.state.formErrors.date ?<Typography variant='caption' color={wyzrTheme.palette.error.light} >
                                        {this.state.formErrors.date}
                                        </Typography>: null }
                                        </Box>
                                    </Box>
                                   
                                    {this.state.selectedIcon ?
                                        <>
                                        <Divider />
                                            <Box className="flex-center-top" mt={2} mb={1} sx={{ justifyContent: "space-between !important" }}>
                                                <Typography fontWeight="800" fontSize="inherit" >Icon Selected</Typography>
                                                <Stack direction="row" gap={1}>
                                                    <img height={30} src={this.state.selectedIcon} alt=""/>
                                                    <Button onClick={this.clearIcon} size="small" endIcon={<DeleteRoundedIcon />} variant="text">
                                                        Clear
                                                    </Button>
                                                </Stack>
                                            </Box>
                                            
                                        </> :
                                        <Box className="flex-center-all" mt={2} mb={1}>
                                            <Button variant="outlined" text color="primary" onClick={this.openIconDialog}>
                                                Choose Icon
                                            </Button>
                                        </Box>
                                        
                                    }
                                    <Box sx={{ 
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                     }}>

                                    {this.state.formErrors.icon ?<Typography variant='caption' color={wyzrTheme.palette.error.light} >
                                    {this.state.formErrors.icon}
                                        </Typography>: null }
                                    </Box>
                                </Box>

                                <Box maxWidth={360} mx="auto" marginTop={5}>

                                    <GradientButton sx={{ width: "50%", display: "block", margin: "auto" }} disabled={this.state.showLoader} onClick={() => {this.submitForm()}}>
                                        {this.state.showLoader ? this.loader() : "CREATE"}
                                    </GradientButton>
                                </Box>
                            </Box>
                        </CardContent>
                    </Grid>
                </Card>
                {updateHeightAfterContentUpdate("parent_SavingEnvelopes", "child_CreateNewEnvelope")}

            <IconDialog
                    showIconDialog={this.state.showIconDialog}
                    closeHandler={this.closeIconDialog}
                />
            </>
        );
    }
}

export default CreateNewEnvelope
